import c from './_directoryHeader.module.scss';

import clsx from 'clsx';

interface DirectoryHeaderProps {
  className?: string;
  children: React.ReactNode;
  enableHeaderCompatibilityFix?: boolean;
}

export function DirectoryHeader({ className, children, enableHeaderCompatibilityFix = false }: DirectoryHeaderProps) {
  return (
    <div className={clsx(c.wrapper, className, { [c.compatibilityFixEnabled]: enableHeaderCompatibilityFix })}>
      {children}
    </div>
  );
}
